import { Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Dispatch, SetStateAction, useState } from "react";
import Loader from "../../Shared/Loader";
import { toast } from "react-toastify";
import { DeleteMassiveProductInvoicingAPI } from "../../../API/invoicingAPI";
import { IResponseProps } from "../../../interfaces/IResponseProps";
import { FaArrowRight } from "react-icons/fa";
import { Button } from "@mui/material";


interface IDeleteProductMassiveModalProps {
    isOpen: boolean;
    toggleModal: () => void
    serviceId: string
    invoicingType: number
    isNotLinked: boolean;
    productId: string | undefined;
}

export function ModalDeleteProductInvoicingMassive({ serviceId, isOpen, toggleModal, invoicingType, isNotLinked, productId }: IDeleteProductMassiveModalProps) {
    const [loading, setLoading] = useState(false);
    const [textConfirm, setTextConfirm] = useState("");



    const handleChange = (event: { target: { value: SetStateAction<string>; }; }) => {
        setTextConfirm(event.target.value);
    };

    async function deleteAll(confirm: string) {
        if (confirm === "Sim") {
            try {
                setLoading(true);

                await DeleteMassiveProductInvoicingAPI(serviceId, invoicingType, isNotLinked, productId).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        toast.success("Produtos deletados com sucesso !!")
                    }
                });
            } catch (error: any) {
                toast.error(error);
            } finally {
                setLoading(false);

            }
        }
        else {
            toast.error("Texto de confirmação inválido !!");
        }
    }




    return (
        <>
            {loading && <Loader />}
            <Modal isOpen={isOpen} toggle={toggleModal} className='modal-lg width rounded'>
                <ModalHeader className="w-100 d-flex flex-column" toggle={toggleModal}>
                    <div className="d-flex justify-content-center align-items-center">
                        <h4>Tem certeza que deseja excluir todos os itens?</h4>
                    </div>
                </ModalHeader>

                <ModalBody className='bg-light'>
                    <div className="my-2">
                        <h6>Para confirmar a exclusão de todos os itens, digite "Sim" </h6>

                        <div className="d-flex justify-content-between my-4">
                            <Input type="text" name="textConfirm" value={textConfirm} onChange={handleChange} style={{ width: "85%" }} />
                            <Button onClick={() => deleteAll(textConfirm)} variant="contained" className="btn ms-2" style={{ width: "15%" }} ><FaArrowRight /></Button>
                        </div>
                    </div>

                </ModalBody>
            </Modal>
        </>
    )

}
